import { render } from "./SliderCardBasic.vue?vue&type=template&id=63338e65"
import script from "./SliderCardBasic.vue?vue&type=script&lang=js"
export * from "./SliderCardBasic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__